
import { defuFn } from '/Users/kevin/Coding/msm/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default defuFn(inlineConfig)
